module.exports = __webpack_public_path__ + "media/images/icon__infoBox--rb-gray@3x-945c5e0025c7a5cfe53ded47485e688c.png";